import {
  createEventBus
} from "./chunk-GVKBGR5N.mjs";
import "./chunk-7ELT755Q.mjs";

// src/clerkEventBus.ts
var clerkEvents = {
  Status: "status"
};
var createClerkEventBus = () => {
  return createEventBus();
};
export {
  clerkEvents,
  createClerkEventBus
};
//# sourceMappingURL=clerkEventBus.mjs.map